import { QrcodeProductDresscodeLine } from 'Components/lines/qrcode-product-dresscode/QrcodeProductDresscodeLine';
export default QrcodeProductDresscodeLine;
